import { render, staticRenderFns } from "./CCOnIcon.vue?vue&type=template&id=195b2047&"
import script from "./CCOnIcon.vue?vue&type=script&lang=js&"
export * from "./CCOnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports